import { render } from "./MainCartSheet.vue?vue&type=template&id=328fd1b8&scoped=true"
import script from "./MainCartSheet.vue?vue&type=script&lang=js"
export * from "./MainCartSheet.vue?vue&type=script&lang=js"

import "./MainCartSheet.vue?vue&type=style&index=0&id=328fd1b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328fd1b8"]])

export default __exports__